import React from 'react';
import { useMobile } from './MobileContext';
import { splitTenantBrand } from './tenantLabel';
import { C } from './MobileShell';

function ort(name) {
  const parts = splitTenantBrand(name);
  return parts.place || parts.brand || name;
}

/** Zweite Zeile im Kopf: die Schulen dieser Lehrkraft. */
export default function SchoolSwitchControl({ light = false }) {
  const { area, schools, teacherId, switchSchool } = useMobile();
  const list = schools || [];
  if (area !== 'lehrer' && area !== 'personal') return null;
  if (list.length < 2) return null;

  const fg = light ? '#fff' : C.text;
  const bg = light ? 'rgba(255,255,255,0.18)' : C.bg;
  const border = light ? 'rgba(255,255,255,0.35)' : C.border;
  const activeBg = light ? '#fff' : C.header;
  const activeFg = light ? C.header : '#fff';

  return (
    <div
      role="group"
      aria-label="Schule wechseln"
      data-testid="mobile-school-toggle"
      className="flex items-center rounded-full p-0.5 mt-1 max-w-full"
      style={{ background: bg, border: `1px solid ${border}` }}
    >
      {list.map((school) => {
        const on = school.teacher_id === teacherId;
        return (
          <button
            key={school.teacher_id}
            type="button"
            data-testid={`mobile-school-${school.tenant_id}`}
            aria-pressed={on}
            onClick={() => switchSchool(school.teacher_id)}
            className="rounded-full px-2 py-0.5 text-[10px] font-bold truncate"
            style={{ background: on ? activeBg : 'transparent', color: on ? activeFg : fg }}
          >
            {ort(school.tenant_name)}
          </button>
        );
      })}
    </div>
  );
}
